import styles from "./MedicalRequestPopupController.module.scss";

interface IMedicalRequestRowComponentProps {
    label?: string,
    children?: string | JSX.Element | JSX.Element[],
    dataCy: string,
    className?: string,
    shouldHide?: boolean
}

function MedicalRequestFormRowComponent(props: IMedicalRequestRowComponentProps): JSX.Element {
    if (!!props.shouldHide)
        return null;

    const content = typeof props.children === "string" ? <p>{props.children}</p> : props.children;
    const additionalClassName = props.className ? `${props.className + " "}` : "";
    const label = props.label ? cacheStore.GetString(props.label) : "";

    return (
        <div className={`${additionalClassName} ${styles.medicalRequestRow}`} data-cy={props.dataCy}>
            <span className={styles.medicalRequestRowLabel}>{label}</span>
            {content}
        </div>
    );
}

export { IMedicalRequestRowComponentProps, MedicalRequestFormRowComponent };
